import _                 from 'underscore';
import React, { FC }     from 'react';
import { Icon, Message } from 'semantic-ui-react';
import { ClassValue }    from 'classnames/types';

import { SystemAccountingQueries } from '../../../queries';
import { CorvalAccountLike, Uuid } from '../../../types';
import { ItemFromQuery }           from '../from-query/ItemFromQuery';

interface OrganizationUserProps {
	accountId: Uuid,
	organizationId: Uuid,
	loadingLabel?: string,
	className?: ClassValue,
	as?: any,
	
	[ additionalProps: string ]: any
}

const defaultProps: OrganizationUserProps = {
	as:             'span',
	accountId:      null,
	organizationId: null,
	className:      null,
	loadingLabel:   'Finding user...',
}

const OrganizationUser: FC<OrganizationUserProps> = ( _props ) => {
	
	let { accountId, organizationId, className, ...props } = _props;
	
	if( !accountId || !organizationId ) return null;
	
	return (
		
		<ItemFromQuery
			as={ props.as }
			className={ className }
			query={ SystemAccountingQueries.queries.GET_ORGANIZATION( `
				organizationMembers{
					accountId
					account{
						id
						emailAddress
						firstName
						lastName
						systemRole
						createdUtc
						updatedUtc
					}
				}`
			) }
			queryOptions={ {
				variables: { id: organizationId }
			} }
			queryResultObject={ ( data: any ) => {
				
				let member = _.findWhere( data.organizations[ 0 ].organizationMembers, { accountId } );
				
				return _.isUndefined( member ) ? { id: accountId } : member.account;
			} }
			loadingComponent={ () => (
				<span className={ 'display--inline-block margin-xs-horizontal' }>
					<Icon loading name='circle notch'/>{ props.loadingLabel && ' ' }{ props.loadingLabel }
				</span>
			) }
			noItemComponent={ () => (
				<Icon.Group>
					<Icon size='small' color='red' name='dont'/>
					<Icon color='black' name='user'/>
				</Icon.Group>
			) }>
			
			{ ( item: CorvalAccountLike ) => _.isFunction( props.children ) ? props.children( item ) : props.children }
		
		</ItemFromQuery>
	);
};

OrganizationUser.defaultProps = defaultProps;

export { OrganizationUser }
